import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useConfluenceAutomationsBaseEligibility = (): boolean => {
	const { isRovoLLMEnabled, edition, isLoggedIn } = useSessionData();

	return (
		isLoggedIn &&
		isRovoLLMEnabled &&
		(edition === ConfluenceEdition.STANDARD || edition === ConfluenceEdition.PREMIUM)
	);
};
